import { Navigate, useRoutes } from "react-router-dom";

import Login from "./Pages/Login";
import SignUp from "./Pages/Sign Up";
import SetupAccount from "./Pages/Sign Up/setup-account";
import LoginWithUniqueContactID from "./Pages/Login/login-with-unique-contact-ID";
import PartnerSignUp from "./Pages/Login/partner-signup";
import PlaidCoreExchangeAuthorize from "./Pages/Plaid Core Exchange";
import Welcome from "./Pages/Welcome";
import Unclaimed from "./Pages/Unclaimed";
import Banking from "./Pages/Banking";
import BankMigration from "./Pages/Bank Migration/bank-migration";
import BankMigrationSettingUp from "./Pages/Bank Migration/bank-migration-setting-up";
import BankMigrationStatus from "./Pages/Bank Migration/bank-migration-status";
import BankMigrationAcknowledgement from "./Pages/Bank Migration/bank-migration-acknowledgement";
import Renting from "./Pages/Renting";
import CashPage from "./Pages/Cash";
import CreditBuilderSettings from "./Pages/Credit Builder";
import Profile from "./Pages/Profile";
import PersonalInformation from "./Pages/Personal Information";
import ConnectedAccountsPage from "./Pages/Connected Accounts";
// import DebitCardsPage from "./Pages/Debit Cards";
import AddCash from "./Pages/Cash Transaction Pages/add-cash";
import CashOut from "./Pages/Cash Transaction Pages/cash-out";
import VenmoTransfer from "./Pages/Cash Transaction Pages/venmo-transfer";
import MailACheck from "./Pages/Cash Transaction Pages/mail-a-check";
import BankingLimits from "./Pages/Banking Limits";
import DirectDeposit from "./Pages/Direct Deposit";
import RecurringDepositsPage from "./Pages/Recurring Deposits";
import ManageStakeDebit from "./Pages/Manage Stake Debit";
import RentPayment from "./Pages/Rent Payment";
import RentPaymentDetails from "./Pages/Rent Payment/rent-payment-details";
import RentPaymentActivity from "./Pages/Rent Payment/rent-payment-activity";
import ManagePayeePage from "./Pages/Manage Payee";
import Deals from "./Pages/Deals";
import StakeSaver from "./Pages/Stake Saver";
import SSO from "./Pages/SSO";
import NeighborhoodNetwork from "./Pages/Neighborhood Network";
import NeighborhoodNetworkCards from "./Pages/Neighborhood Network/cards";
import NeighborhoodNetworkBrandsAndOffers from "./Pages/Neighborhood Network/brands-and-offers";
import NeighborhoodNetworkRewards from "./Pages/Neighborhood Network/rewards";
import NeighborhoodNetworkOffersNearYou from "./Pages/Neighborhood Network/offers-near-you";
import InsuranceManage from "./Pages/Insurance/Manage";
import MyUtilitiesManage from "./Pages/MyUtilities/manage";
import VerifyStakeChecking from "./Pages/Verify Stake Checking";
import BattlecardRouteGuard from "./Pages/Onboarding/battlecard-route-guard";
import BattleCards from "./Pages/Onboarding/battle-cards";
import LegacyRebateTerms from "./Pages/Onboarding/legacy-rebate-terms";
import CheckWarning from "./Pages/Onboarding/check-warning";
import CheckMailingAddress from "./Pages/Onboarding/check-mailing-address";
import CheckOnTheWay from "./Pages/Onboarding/check-on-the-way";
import CheckNotProcessed from "./Pages/Onboarding/check-not-processed";
import StartShopping from "./Pages/Onboarding/start-shopping";
import PayRent from "./Pages/Onboarding/pay-rent";
import MemberSetup from "./Pages/Onboarding/member-setup";
import MemberSetupAddFunds from "./Pages/Onboarding/member-setup-add-funds";
import InstantReleasePage from "./Pages/InstantRelease/instant-release";
import StakeUtilitiesPage from "./Pages/StakeUtilities/stake-utilities";
import ErrorPage from "./Components/Others/error-page";

import AppComponentWrapper from "./Organisms/Wrappers/app-component-wrapper";

import { useAppUtilityContext } from "./Contexts/AppUtilityContext";
import { RedirectContextProvider } from "./Contexts/RedirectContext";

import { isDevReactEnv } from "./Utils/constants";

function Routes() {
  const {
    appUtilityProps: { hideDealsRoutes },
  } = useAppUtilityContext();

  let routes = useRoutes([
    {
      path: "/",
      element: <RedirectContextProvider />,
      children: [
        { path: "login", element: <Login /> },
        { path: "welcome", element: <Welcome /> },
        { path: "welcome/find-a-home", element: <Welcome /> },
        { path: "unclaimed", element: <Unclaimed /> },
        { path: "setup-account", element: <SetupAccount /> },
        { path: "apply-stake-checking", element: <SSO applyStakeChecking /> },
        { path: "bank-migration-details", element: <SSO bankMigrationDetails /> },
        { path: "bank-migration-setting-up", element: <BankMigrationSettingUp /> },
        { path: "verify-stake-checking", element: <VerifyStakeChecking /> },
        ...(hideDealsRoutes ? [] : [{ path: "deals/setup-stake-saver", element: <SSO setupStakeSaver /> }]),
        {
          path: "/",
          element: <AppComponentWrapper />,
          children: [
            { path: "/", element: <Navigate to="login" /> },
            { path: "cash-out", element: <CashOut /> },
            { path: "venmo-transfer", element: <VenmoTransfer /> },
            { path: "mail-a-check", element: <MailACheck /> },
            ...(hideDealsRoutes
              ? []
              : [
                  {
                    path: "deals",
                    children: [
                      { path: "", element: <Deals /> },
                      { path: "stake-saver", element: <StakeSaver /> },
                      { path: "credit-builder", element: <CreditBuilderSettings /> },
                      {
                        path: "neighborhood-network",
                        children: [
                          { path: "", element: <NeighborhoodNetwork /> },
                          { path: "linked-cards", element: <NeighborhoodNetworkCards /> },
                          { path: "brands-and-offers", element: <NeighborhoodNetworkBrandsAndOffers /> },
                          { path: "rewards", element: <NeighborhoodNetworkRewards /> },
                          { path: "offers-near-you", element: <NeighborhoodNetworkOffersNearYou /> },
                        ],
                      },
                      { path: "insurance/manage", element: <InsuranceManage /> },
                      { path: "my-utilities/manage", element: <MyUtilitiesManage /> },
                    ],
                  },
                ]),

            {
              path: "home",
              element: <Banking />,
            },
            { path: "instant-release", element: <InstantReleasePage /> },
            { path: "stake-utilities", element: <StakeUtilitiesPage /> },
            {
              path: "battlecard",
              element: <BattlecardRouteGuard />,
              children: [
                { index: true, element: <BattleCards /> },
                { path: "legacy-terms", element: <LegacyRebateTerms /> },
                { path: "validate-address", element: <CheckWarning /> },
                { path: "check-mailing-address", element: <CheckMailingAddress /> },
                { path: "check-on-the-way", element: <CheckOnTheWay /> },
                { path: "check-not-processed", element: <CheckNotProcessed /> },
                { path: "start-shopping", element: <StartShopping /> },
                { path: "pay-rent", element: <PayRent /> },
                { path: "member-setup", element: <MemberSetup /> },
                { path: "add-funds", element: <MemberSetupAddFunds /> },
              ],
            },
            { path: "connected-accounts", element: <ConnectedAccountsPage /> },
            { path: "add-cash", element: <AddCash /> },
            { path: "banking-limits", element: <BankingLimits /> },
            { path: "direct-deposit", element: <DirectDeposit /> },
            { path: "recurring-deposits", element: <RecurringDepositsPage /> },
            { path: "manage-stake-debit", element: <ManageStakeDebit /> },
            {
              path: "cash",
              children: [
                { path: "", element: <CashPage /> },
                {
                  path: "one-time-payment",
                  element: <RentPayment />,
                },
                {
                  path: "recurring-payment",
                  children: [
                    {
                      path: "",
                      element: <RentPayment isRecurringTransaction />,
                    },
                    {
                      path: "view/:recurringId",
                      element: <RentPaymentDetails />,
                    },
                  ],
                },
                { path: "rent-payment-activity", element: <RentPaymentActivity /> },
                { path: "manage-payees", element: <ManagePayeePage /> },
              ],
            },
            {
              path: "profile",
              children: [
                { path: "", element: <Profile /> },
                { path: "personal-information", element: <PersonalInformation /> },
              ],
            },
            { path: "bank-account-migration", element: <BankMigration /> },
            { path: "bank-migration-acknowledgement", element: <BankMigrationAcknowledgement /> },
            { path: "bank-migration-status", element: <BankMigrationStatus /> },
          ],
        },
      ],
    },
    ...(isDevReactEnv ? [{ path: "sign-up", element: <SignUp /> }] : []),
    { path: "plaid-core-exchange/authorize", element: <PlaidCoreExchangeAuthorize /> },
    { path: "login-with-unique-id", element: <LoginWithUniqueContactID /> },
    { path: "partner-signup", element: <PartnerSignUp /> },
    { path: "*", element: <ErrorPage isPageNotFound /> },
  ]);
  return routes;
}

export default Routes;
